NtechApp.FormSaver = function($form, saveRoute, redirectRoute, beforeSave, afterSave) {
    var me = this;

    this._$form = null;
    this._saveRoute = null;
    this._redirectRoute = null;

    this._click = null;
    this._ajax = null;
    this._formDataParser = null;

    //this._overlay = null;
    this._submitLoader = null;
    this._beforeSave = null;
    this._afterSave = null;
    this._onError = null;

    this._cancelRequest = false;

    this._construct = function() {
        me._$form = $form;
        me._saveRoute = saveRoute;
        me._redirectRoute = redirectRoute;

        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();
        me._formDataParser = new NtechApp.FormDataParser();

        //me._overlay = new NtechApp.Overlay($("body"), {background: "transparent"});
        me._submitLoader = new NtechApp.Loader(25, 25, "absolute", me._$form.find(":submit").parent());
        me._beforeSave = beforeSave || function() { me._save.call(me); };

        var redirectCb = function() {
            window.location.href = NtechApp.config.baseUrl + Routing.generate(me._redirectRoute);
        };

        if(afterSave) {
            me._afterSave = function() { 
                afterSave(redirectCb);
            };
        }
        else {
            me._afterSave = redirectCb;
        }
        
        me._bindEvents();
    }

    this._bindEvents = function() {
        me._$form.find("form").submit(function(event) {
            event.preventDefault();

            me._enableLoader.call(me);
            me._beforeSave.call(me, function() {
                me._save.call(me);
            });

            return false;
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.FormSaver.EVENT_POSTSET_FORMDATA = "NtechApp.FormSaver.EventPostsetFormdata";

NtechApp.proto(NtechApp.FormSaver, {
    _enableLoader: function() {
        //this._overlay.on();
        this._submitLoader.on().white();
        this._submitLoader.getView().addClass("ntechapp-loader-light").css({
            "border-radius": "69px"
        });
    },

    _disableLoader: function() {
        //this._overlay.off();
        this._submitLoader.off();
    },

    setOnError: function(onError) {
        this._onError = onError;
    },

    start: function() {
        this._enableLoader();
    },

    stop: function() {
        this._disableLoader();
    },

    cancelRequest: function() {
        this._cancelRequest = true;
    },

    getRequestData: function() {
        var requestData = {};
        requestData.modelFormData = this._formDataParser.getFormJSON(this._$form.find("form"));

        $(this).trigger(NtechApp.FormSaver.EVENT_POSTSET_FORMDATA, [requestData]);
        return requestData;
    },

    _save: function() {
        var me = this;
        if(this._onError == null) {
            this._onError = function(errors) {
                me.showErrors(errors);
            };
        }

        var requestData = this.getRequestData();
        if(this._cancelRequest) {
            this._cancelRequest = false;
            return;
        }

        this._ajax.post({
            url: Routing.generate(this._saveRoute),
            data: requestData,
            onSuccess: function(data) {
                me._afterSave.call(me);
            },
            onError: function(errors) {
                me._onError.call(me, errors);
            },
            onComplete: function() {
                me._disableLoader();
            }
        });
    },

    showErrors: function(errors) {
        var me = this;
        var $errors = me._$form.find("[data-formErrorsManager]");

        $errors.css("display", "block");
        $errors.find(".errorBody > p").remove();

        for(var errorName in errors)
            $errors.find(".errorBody").append("<p>" + errors[errorName] + "</p>");
    }
});